<template>
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.193359 15.4999V6.21143L5.69311 0.711426L11.1931 6.21143V15.4999H0.193359ZM1.69311 13.9999H4.80861V11.3462H6.57786V13.9999H9.69311V6.82493L5.69311 2.82493L1.69311 6.82493V13.9999ZM4.80861 8.88443V7.11543H6.57786V8.88443H4.80861ZM13.0009 15.5094V5.46342L8.24886 0.711426H10.3721L14.5009 4.84043V15.5094H13.0009ZM16.3086 15.5094V4.09218L12.9279 0.711426H15.0604L17.8084 3.46918V15.5094H16.3086Z"
        fill="#1E264C"
      />
    </svg>
</template>